export default {
  methods: {
    $_nonBestPriceWinnerNames(tender) {
      const detailsKey = tender?.lotGroups?.length ? 'bidGroupDetails' : 'bidDetails'
      const names = new Set()
      tender?.bids?.forEach(bid => {
        const hasNonBestPriceWin = bid[detailsKey]?.some(
          detail => detail.bidDecisionAttribute === 'WINNER' && detail.bestPrice === false
        )
        if (hasNonBestPriceWin && bid.bidderInfo?.organizationName) {
          names.add(bid.bidderInfo.organizationName)
        }
      })
      return [...names]
    },
    $_showWinnerReasonModal(tender) {
      return this.$can('show', 'requireNonBestPriceWinnerReason') &&
        !!this.growthBook?.requireNonBestPriceWinnerReason &&
        this.$_nonBestPriceWinnerNames(tender).length > 0
    }
  }
}
